import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getPersonalKycRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.getPersonalKyc,
    data,
    true,
    true
  );
};

export const postPersonalKycRequest = async (data = {}) => {
  return apiRequest(
    methodType.POST,
    apiEndPoints.postPersonalKYC,
    data,
    true,
    true
  );
};

export const patchPersonalKycRequest = async (shareholderId, data = {}) => {
  return apiRequest(
    methodType.PATCH,
    apiEndPoints.patchPersonalKYC(shareholderId),
    data,
    true,
    true
  );
};
